import { render } from "./Detail.vue?vue&type=template&id=7d273ed7&scoped=true&ts=true"
import script from "./Detail.ts?vue&type=script&lang=ts"
export * from "./Detail.ts?vue&type=script&lang=ts"

import "./Detail.scss?vue&type=style&index=0&id=7d273ed7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d273ed7"]])

export default __exports__